import { createFileRoute } from "@tanstack/react-router";

import { JourneyPage } from "@/components/journey-page";

export const Route = createFileRoute("/solid")({
  head: () => ({
    meta: [
      { property: "og:url", content: "https://www.luizajesusdoprado.com/solid" },
      { title: "Solid — Sculpture & Object | Luiza Jesus do Prado" },
      {
        name: "description",
        content:
          "Sculpture and object works by Luiza Jesus do Prado — matter, residue and assembled memory.",
      },
      { property: "og:title", content: "Solid — Sculpture & Object | Luiza Jesus do Prado" },
      { property: "og:description", content: "Sculpture and object works." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: () => <JourneyPage journeyKey="solid" />,
});
